import { axiosReqCerClient } from '../plugins/axios'
import { axiosHrClient } from '../plugins/axios'

const reqcer = {
  namespaced: true,

  actions: {
    getBasicInfo() {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosReqCerClient.get(`/User/self`)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    getCertInfo(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosReqCerClient.get(
            `/ReqCert/` + payload + `/self`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    getCertInfoAdmin(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosReqCerClient.get(
            `/ReqCert/` + payload + `/admin`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    deleteCert(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosReqCerClient.delete(
            `/ReqCert/` + payload + `/self`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    getOldEmpBasicInfo(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosReqCerClient.get(`/AdminReqOldEmp`, {
            headers: {
              personalid: payload
            }
          })
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    getUserList(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosReqCerClient.get(`/ReqCert/self`, {
            params: payload
          })
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    getAdminList(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosReqCerClient.post(`/ReqCert/admin`, payload)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    importDoc(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData()
          formData.append('filename1', payload.file)
          const res = await axiosReqCerClient.post(
            `/ReqCert/` + payload.cercode + `/docfile`,
            formData
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    addNewRequest(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosReqCerClient.post(`/ReqCert/self`, payload)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    addNewRequestOldEmp(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosReqCerClient.post(`/AdminReqOldEmp`, payload)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    getOrgParent() {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `/hr/self/organization/2/accessrole/122/parent`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    getOrgChild(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `/hr/self/organization/2/accessrole/122/parent/` +
              payload +
              `/child`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    getEmpTypeList() {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(`/hrreference/employeetypeall`)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    getExecList() {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosReqCerClient.get(`/SignNameList/All`)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    getSystemMenus(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `/hrportal/employees/` +
              payload +
              `/menusystems/4/programcatelogs/122`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    getSystemMenusAdmin() {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `/hrportal/self/catelogroles/122/programitemroles`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    getSignList() {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosReqCerClient.get(`/Sign/All/1`)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    addSign(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosReqCerClient.post(`/Sign`, payload)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    deleteSign(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosReqCerClient.delete(`/Sign/` + payload)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    putApproveStatus(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosReqCerClient.put(
            `/ReqCert/` + payload.cercode + `/ApproveStatus/` + payload.statusId
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    getPreviewData(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosReqCerClient.get(
            `/ReqCert/` + payload + `/preview`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    putPreviewData(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosReqCerClient.put(`/preview`, payload)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    getDownloadFile(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosReqCerClient.get(
            `/ReqCertID/` + payload.id + `/self/download/` + payload.fileName,
            { responseType: 'blob' }
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    getDownloadDoc(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosReqCerClient.get(
            `/ReqCertID/` + payload.cercode + `/docfile/` + payload.fileName,
            { responseType: 'blob' }
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    }
  }
}

export default reqcer
